// aldoo-ra/AldooComponent/reader.js
// Use Vite's glob import for component auto-discovery
const defaultComponents = import.meta.glob("/aldoo-ra/**/index.jsx", {
  eager: true,
})

// User components in the components folder - all .jsx files
const userComponents = import.meta.glob("/components/**/*.jsx", {
  eager: true,
})

// Debug: uncomment to see discovered files
// console.log('🔍 AldooComponent: Auto-discovery initialized')
// console.log('📁 Found default component files:', Object.keys(defaultComponents))
// console.log('📁 Found user component files:', Object.keys(userComponents))

export class ComponentReader {
  static #componentCache = new Map()
  static initialized = false
  static #initializing = false

  static init() {
    if (this.initialized || this.#initializing) return

    this.#initializing = true

    // Auto-discover components from aldoo-ra modules
    Object.entries(defaultComponents).forEach(([path, module]) => {
      if (module.AldooComponent && typeof module.AldooComponent === 'object') {
        const definition = module.AldooComponent
        if (definition.id && definition.component) {
          this.#componentCache.set(definition.id, definition)
        }
      }
    })

    // Auto-discover components from user components
    Object.entries(userComponents).forEach(([path, module]) => {
      if (module.AldooComponent && typeof module.AldooComponent === 'object') {
        const definition = module.AldooComponent
        if (definition.id && definition.component) {
          this.#componentCache.set(definition.id, definition)
        }
      }
    })

    this.#initializing = false
    this.initialized = true
  }

  static registerComponent(definition) {
    if (!this.initialized && !this.#initializing) {
      this.init()
    }

    if (!definition.id || !definition.component) {
      throw new Error('Component definition must have both id and component properties')
    }

    this.#componentCache.set(definition.id, definition)
  }

  static getComponent(id) {
    if (!this.initialized && !this.#initializing) {
      this.init()
    }

    return this.#componentCache.get(id)
  }

  static getComponents() {
    if (!this.initialized && !this.#initializing) {
      this.init()
    }

    return Array.from(this.#componentCache.values())
  }

  static getRegistry() {
    if (!this.initialized && !this.#initializing) {
      this.init()
    }

    return this.#componentCache
  }

  static clearCache() {
    this.#componentCache.clear()
    this.initialized = false
    this.#initializing = false
  }
}